import _regeneratorRuntime from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Class } from "../utils";
import icons from "../resources/icons";
/**
 *
 * @class DetailsHandlerDef
 *
 */

export default Class({
  initialize: function initialize(options) {
    /**
     Indicates whether the details provided should be considered an extension of the result rather than related information (Layouts may show "more" handlers at the top without specific heading)
     @name Result#more
     @type Boolean
     */
    this.more = false;
    this.buttonText = "";
    this.buttonImage = icons.infoGrey;
    this.description = "";
    this.id = '_' + Math.floor(Math.random() * 999999999);
    this.handlerFunction =
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", []);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    this.isApplicableFunction = function () {
      return true;
    };

    if (typeof options !== 'undefined') {
      if (options.more) this.more = options.more;
      if (options.buttonText) this.buttonText = options.buttonText;
      if (options.buttonImage) this.buttonImage = options.buttonImage;
      if (options.description) this.description = options.description;
      if (options.handler) this.handlerFunction = options.handler;
      if (options.isApplicable) this.isApplicableFunction = options.isApplicable;
    }
  },
  getbuttonText: function getbuttonText() {
    return this.buttonText;
  },
  getbuttonImage: function getbuttonImage() {
    return this.buttonImage;
  },
  handler: function handler(result, renderAsMore) {
    if (typeof renderAsMore !== 'undefined' && renderAsMore !== this.more) {
      this.more = !this.more;
      var handlerResult = this.handlerFunction(result);
      this.more = !this.more;
      return handlerResult;
    } else {
      return this.handlerFunction(result);
    }
  },
  isApplicable: function isApplicable(result) {
    return this.isApplicableFunction(result);
  },
  CLASS_NAME: 'Septima.Search.DetailsHandlerDef'
});